import { render, staticRenderFns } from "./_filter_by_version.vue?vue&type=template&id=36676558&"
import script from "./_filter_by_version.vue?vue&type=script&lang=js&"
export * from "./_filter_by_version.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports